import { aboutData } from '@/mocks/articleData';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SchemaOrg from '@/components/base/SchemaOrg';

export default function AboutPage() {
  const aboutSchema = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于我们 - 福利视频网址大全',
    description: aboutData.intro,
    url: '/about',
    mainEntity: {
      '@type': 'Organization',
      name: '福利视频网址大全',
      description: aboutData.intro,
      foundingDate: '2020',
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: 'customer service',
        email: 'contact@example.com',
      },
    },
  };

  return (
    <>
      <SchemaOrg data={aboutSchema} />
      <main>
        <div className="pt-20 pb-14 md:pb-20">
          <div className="max-w-5xl mx-auto px-4 md:px-6">
            <Breadcrumb
              items={[
                { label: '首页', to: '/' },
                { label: '关于我们' },
              ]}
            />

            <section className="mt-8 text-center">
              <h1 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-4">
                关于我们
              </h1>
              <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
                {aboutData.intro}
              </p>
            </section>

            <section className="mt-16">
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-8 text-center">
                我们的使命
              </h2>
              <div className="bg-accent-500 rounded-2xl p-8 md:p-12 text-center">
                <div className="w-16 h-16 mx-auto mb-5 flex items-center justify-center bg-white/20 rounded-2xl">
                  <i className="ri-star-line text-2xl text-background-50"></i>
                </div>
                <p className="text-background-50 text-base md:text-lg leading-relaxed max-w-2xl mx-auto">
                  {aboutData.mission}
                </p>
              </div>
            </section>

            <section className="mt-16">
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-8 text-center">
                核心价值
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
                {aboutData.values.map((v, i) => (
                  <div
                    key={i}
                    className="bg-background-100 rounded-xl p-6 text-center hover:bg-accent-50 transition-all duration-300 border border-transparent hover:border-accent-200"
                  >
                    <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center bg-accent-100 rounded-xl">
                      <i className={`ri-${['refresh-line', 'shield-check-line', 'gift-line', 'heart-line'][i]} text-xl text-accent-600`}></i>
                    </div>
                    <h3 className="font-heading text-base font-semibold text-foreground-800 mb-2">
                      {v.title}
                    </h3>
                    <p className="text-sm text-foreground-500 leading-relaxed">{v.desc}</p>
                  </div>
                ))}
              </div>
            </section>

            <section className="mt-16">
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-8 text-center">
                发展历程
              </h2>
              <div className="relative">
                <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-0.5 bg-background-200 md:-translate-x-px"></div>
                <div className="space-y-8">
                  {aboutData.milestones.map((m, i) => (
                    <div
                      key={i}
                      className={`relative flex flex-col md:flex-row gap-4 md:gap-0 ${
                        i % 2 === 0 ? '' : 'md:flex-row-reverse'
                      }`}
                    >
                      <div className="absolute left-4 md:left-1/2 w-3 h-3 rounded-full bg-accent-500 -translate-x-1/2 mt-2 z-10"></div>
                      <div className={`pl-10 md:pl-0 md:w-1/2 ${i % 2 === 0 ? 'md:pr-10 md:text-right' : 'md:pl-10'}`}>
                        <div className="bg-background-100 rounded-xl p-5 inline-block max-w-md">
                          <span className="text-xs font-bold text-accent-600">{m.year}</span>
                          <p className="text-sm text-foreground-700 mt-1">{m.event}</p>
                        </div>
                      </div>
                      <div className="hidden md:block md:w-1/2"></div>
                    </div>
                  ))}
                </div>
              </div>
            </section>

            <section className="mt-16">
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-8 text-center">
                用户口碑
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                {aboutData.testimonials.map((t, i) => (
                  <div key={i} className="bg-background-100 rounded-xl p-6">
                    <div className="flex items-center gap-1 mb-3">
                      {Array.from({ length: 5 }).map((_, j) => (
                        <i
                          key={j}
                          className={`ri-star-fill text-sm ${
                            j < t.rating ? 'text-accent-500' : 'text-background-300'
                          }`}
                        ></i>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                      &ldquo;{t.text}&rdquo;
                    </p>
                    <span className="text-sm font-medium text-foreground-800">
                      &mdash; {t.name}
                    </span>
                  </div>
                ))}
              </div>
            </section>

            <section className="mt-16 bg-background-100 rounded-2xl p-8 md:p-12">
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-6 text-center">
                联系我们
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-3xl mx-auto text-center">
                <div className="p-5">
                  <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center bg-accent-100 rounded-xl">
                    <i className="ri-mail-line text-xl text-accent-600"></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-800 mb-1">电子邮箱</h3>
                  <a href="mailto:contact@example.com" className="text-sm text-accent-600 hover:text-accent-700 cursor-pointer">contact@example.com</a>
                </div>
                <div className="p-5">
                  <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center bg-accent-100 rounded-xl">
                    <i className="ri-chat-3-line text-xl text-accent-600"></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-800 mb-1">反馈建议</h3>
                  <p className="text-sm text-foreground-500">发现失效链接或资源问题，欢迎随时反馈</p>
                </div>
                <div className="p-5">
                  <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center bg-accent-100 rounded-xl">
                    <i className="ri-thumb-up-line text-xl text-accent-600"></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-800 mb-1">商务合作</h3>
                  <a href="mailto:business@example.com" className="text-sm text-accent-600 hover:text-accent-700 cursor-pointer">business@example.com</a>
                </div>
              </div>
            </section>
          </div>
        </div>
      </main>
    </>
  );
}